export default __webpack_public_path__ + "static/media/library_2_compressed.e15d2392.jpg";